import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { TSkillCategoryRecord } from "./modal";
import { Fetch } from "../../utilities/fetch";
import { JVInput } from "../../shared/JVInput";
import { useToast } from "../../context/toastProvider";

const schema = yup.object({
    name: yup.string().required("Country Name is required*"),
    description: yup.string().nullable()
});

interface Iprops {
    data: TSkillCategoryRecord,
    open: boolean,
    hideDialog: () => void,
    reload: () => void,
}

export const Form = (props: Iprops) => {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, formState: { errors }, reset } = useForm<TSkillCategoryRecord>({
        resolver: yupResolver(schema),
        defaultValues: props.data,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.data);
    }, [props.data]);

    const saveToDB = async (body: TSkillCategoryRecord) => {
        if (loading) return;
        setLoading(true);

        const id = props.data.id;
        const method = id ? "PUT" : "POST";
        const message = id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(id ? `skillcategories/${id}` : 'skillcategories', {
            method, body,
            onError: (m) => showToast({ severity: 'error', detail: m })
        });

        if (response) {
            props.hideDialog();
            props.reload();
            showToast({ severity: 'success', detail: message });
        }

        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
    }

    function onSubmit(data: TSkillCategoryRecord) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Skill Category" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput required column={1} label="Skill Category Name" control={control} name="name" error={errors.name?.message} />
                <JVInput column={1} label="Description" control={control} name="description" error={errors.description?.message} />
                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit" loading={loading}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
